import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    // If we're already on the home page, scroll directly
    if (location.pathname === '/') {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to home with hash
      navigate('/#contact');
    }
    setIsMobileMenuOpen(false);
  };

  const scrollToVision2030 = () => {
    // If we're already on the home page, scroll directly
    if (location.pathname === '/') {
      const visionSection = document.getElementById('vision2030');
      if (visionSection) {
        visionSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to home with hash
      navigate('/#vision2030');
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 glass-nav ${isScrolled ? 'shadow-lg' : ''}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 flex items-center gap-2 cursor-pointer">
            <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-green-700 rounded-lg flex items-center justify-center text-white font-bold text-xl">
              S
            </div>
            <div>
              <span className="font-bold text-slate-900 text-lg tracking-tight block leading-none">STHLM</span>
              <span className="text-xs text-slate-500 uppercase tracking-widest">Tech Partner</span>
            </div>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-slate-600 hover:text-green-700 font-medium transition">
              Home
            </Link>
            <Link to="/portfolio" className="text-slate-600 hover:text-green-700 font-medium transition">
              Portfolio
            </Link>
            <button
              onClick={scrollToVision2030}
              className="text-slate-600 hover:text-green-700 font-medium transition"
            >
              Vision 2030
            </button>
            <button
              onClick={scrollToContact}
              className="bg-slate-900 text-white px-6 py-2.5 rounded-full font-medium hover:bg-green-700 transition-colors duration-300 shadow-lg"
            >
              Partner With Us
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-slate-600 hover:text-slate-900 focus:outline-none"
            >
              <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'} text-2xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-slate-100 absolute w-full">
          <div className="px-4 pt-2 pb-6 space-y-2 shadow-xl">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-3 py-3 rounded-md text-base font-medium text-slate-700 hover:text-green-700 hover:bg-slate-50"
            >
              Home
            </Link>
            <Link
              to="/portfolio"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-3 py-3 rounded-md text-base font-medium text-slate-700 hover:text-green-700 hover:bg-slate-50"
            >
              Portfolio
            </Link>
            <button
              onClick={scrollToVision2030}
              className="block w-full text-left px-3 py-3 rounded-md text-base font-medium text-slate-700 hover:text-green-700 hover:bg-slate-50"
            >
              Vision 2030
            </button>
            <button
              onClick={scrollToContact}
              className="block w-full px-3 py-3 mt-4 text-center rounded-md text-base font-bold text-white bg-green-700"
            >
              Partner With Us
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
